import ModuleBase from '../shared/ModuleBase.js';

/**
 * NewsFilter — Client-seitige Kategorie-Filterung fuer News Listing
 * Filtert Cards per data-categories Attribut ohne Server-Roundtrip
 */
export default class NewsFilter extends ModuleBase {
    constructor(el) {
        super(el);
        this._init();
    }

    _init() {
        this._filterNav = this.$el.querySelector('[data-news-filter]');
        this._grid = this.$el.querySelector('.news-listing__grid');
        if (!this._filterNav || !this._grid) return;

        this._removeDuplicateButtons();
        this._bindFilter();
    }

    _removeDuplicateButtons() {
        const seen = {};
        const buttons = this._filterNav.querySelectorAll('[data-category]');
        buttons.forEach((btn) => {
            const cat = btn.getAttribute('data-category');
            if (cat === 'all') return;
            if (seen[cat]) {
                btn.remove();
            } else {
                seen[cat] = true;
            }
        });
    }

    _bindFilter() {
        this._filterNav.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-category]');
            if (!btn) return;

            const category = btn.getAttribute('data-category');

            // Active state
            this._filterNav.querySelectorAll('[data-category]').forEach((b) => {
                b.classList.remove('news-category-filter__item--active');
                b.removeAttribute('aria-current');
            });
            btn.classList.add('news-category-filter__item--active');
            btn.setAttribute('aria-current', 'true');

            // Filter cards
            const cards = this._grid.querySelectorAll('[data-categories]');
            cards.forEach((card) => {
                if (category === 'all') {
                    card.style.display = '';
                } else {
                    const cats = card.getAttribute('data-categories').split(',');
                    card.style.display = cats.indexOf(category) !== -1 ? '' : 'none';
                }
            });
        });
    }
}
